<script>
    import * as SharedComponents from "../SharedComponents/index.js";
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";
    import { push } from "svelte-spa-router";
    import { getContext } from "svelte";

    export let product = {
        factorySettingId: "",
        brand: "",
        style: "",
        name: "",
    };
    export let params = {};
    export let returnUrl = "/dashboard/products";
    import IconBack from "../Vectors/back.svelte";
    import { fade, fly } from "svelte/transition";
    import { cubicOut, cubicIn, sineOut } from "svelte/easing";
    const { snackbar } = getContext("app");

    factoryStore.getFactories();
    if (params.factorySettingsId) {
        product.factorySettingId = params.factorySettingsId;
        returnUrl = "/dashboard/factories";
    }

    async function save() {
        if (!product.factorySettingId || product.factorySettingId.length == 0) {
            alert($langTextStore.getText("general-warning-choose-a-factory"));
            return;
        }
        product.uuid = null;
        var productId = await factoryStore.saveProduct(product);
        push("/calculator/product/" + productId);
    }

    function cancel() {
        if (window.location.href.includes("fromfactory")) {
            push(
                "/calculator/factorysettings/" +
                    params.factorySettingsId +
                    "?activesection=productlist"
            );

            return;
        }
        push(returnUrl);
    }
</script>

<button class="back-to-dash" on:click={cancel}>
    <IconBack />
    {$langTextStore.getText("general-label-exit")}
</button>

<div
    class="container align-vertical-middle"
    in:fly={{ y: 250, duration: 1600, easing: sineOut }}
    out:fade={{ duration: 200 }}
>
    <div class="row" in:fade={{ delay: 800 }}>
        <div class="col-12 offset-md-3 col-md-6 bg-gray-8 p-4  box-shadow">
            <div class="innner_modal">
                <h2 class="gray-6 text-center mt-3 mb-5">
                    {$langTextStore.getText("general-header-edit-basic-info")}
                </h2>
                <div>
                    <label for="fixedId"
                        >{$langTextStore.getText(
                            "general-label-factory-preset"
                        )}
                    </label>
                    <SharedComponents.FactorySettingsSelector
                        bind:factorySettingId={product.factorySettingId}
                    />
                </div>
                <div class="mt-1">
                    <label for="name"
                        >{$langTextStore.getText(
                            "general-label-product-name"
                        )}</label
                    >
                    <input
                        bind:value={product.name}
                        id="name"
                        type="text"
                        class="form-control"
                        placeholder={$langTextStore.getText(
                            "general-label-product-name"
                        )}
                    />
                </div>
                <div class="mt-1">
                    <label for="brand"
                        >{$langTextStore.getText("general-label-brand")}
                    </label>
                    <input
                        bind:value={product.brand}
                        id="brand"
                        type="text"
                        class="form-control"
                        placeholder={$langTextStore.getText(
                            "general-label-brand-name"
                        )}
                    />
                </div>
                <div class="mt-1">
                    <label for="style"
                        >{$langTextStore.getText("general-label-style")}
                    </label>
                    <input
                        bind:value={product.style}
                        id="style"
                        type="text"
                        class="form-control"
                        placeholder={$langTextStore.getText(
                            "general-label-style-name"
                        )}
                    />
                </div>
                <div class="w-100 text-right mt-4 mb-3">
                    <button
                        type="button"
                        class="btn btn-gray width-unset "
                        on:click={cancel}
                        >{$langTextStore.getText(
                            "general-label-cancel"
                        )}</button
                    >
                    <button
                        type="button"
                        class="btn btn-primary width-unset"
                        on:click={save}
                        >{$langTextStore.getText("general-label-save")}</button
                    >
                </div>
            </div>
        </div>
    </div>
</div>
